import React from "react";
import { useTheme } from "../context/ThemeContext";

function SunIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M12 2v2M12 20v2M4 12H2M22 12h-2M5.6 5.6 4.2 4.2M19.8 19.8l-1.4-1.4M18.4 5.6l1.4-1.4M4.2 19.8l1.4-1.4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M21 14.5A8.5 8.5 0 0 1 9.5 3a7 7 0 1 0 11.5 11.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ThemeToggle({ className = "" }) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Mode jour" : "Mode nuit"}
      title={isDark ? "Jour" : "Nuit"}
      className={[
        "inline-flex items-center justify-center",
        "w-10 h-10 rounded-full",
        "transition-all duration-300",
        "bg-slate-100 hover:bg-slate-200 text-slate-700",
        "dark:bg-white/10 dark:hover:bg-white/15 dark:text-slate-100",
        className,
      ].join(" ")}
    >
      <span className="flex items-center justify-center w-full h-full">
        {isDark ? (
          <MoonIcon className="w-5 h-5 translate-x-[0.5px]" />
        ) : (
          <SunIcon className="w-5 h-5" />
        )}
      </span>
    </button>
  );
}
